/** biome-ignore-all lint/style/noRestrictedImports: This is the wrapper file for @tanstack/react-router (makes moking easier) */

import { createBrowserHistory } from "@tanstack/history";
import { createRouter } from "@tanstack/react-router";
import { createReloadingHistory } from "./navigation-history";
import { routeTree } from "./routeTree.gen";

const browserHistory = createBrowserHistory();

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
  scrollToTopSelectors: ["#main-scrollable-area"],
  history: createReloadingHistory(browserHistory),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
